import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page43"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
import 空间剧本 from '@/assets/v2/page4/空间剧本.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import tu1 from '@/assets/v2/page4-3/1.webp';
import tu2 from '@/assets/v2/page4-3/2.webp';
import tu3 from '@/assets/v2/page4-3/3.webp';
import 归家 from '@/assets/v2/page4-3/文字/归家.webp';
import 欢聚 from '@/assets/v2/page4-3/文字/欢聚.webp';
import 晚间 from '@/assets/v2/page4-3/文字/晚间.webp';
export default {
  __name: 'Page4-3',
  setup(__props) {
    // 引入图片

    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(空间剧本),
        alt: "空间剧本",
        class: "空间剧本",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('goHome')),
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: _unref(tu1),
        alt: "tu1",
        class: "tu1",
        loading: "lazy"
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: _unref(tu2),
        alt: "tu2",
        class: "tu2",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(tu3),
        alt: "tu3",
        class: "tu3",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(归家),
        alt: "归家",
        class: "归家",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(欢聚),
        alt: "欢聚",
        class: "欢聚",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(晚间),
        alt: "晚间",
        class: "晚间",
        loading: "lazy"
      }, null, 8, _hoisted_9)]);
    };
  }
};